import React, { useEffect, useState } from 'react';
import { Modal, Spinner, ModalBody, ModalHeader, ModalFooter, Button, Col, FormGroup, Label, Input, Row, Card, CardHeader, CardBody } from 'reactstrap';
import DatePicker from 'react-datepicker'
import Select from '../../Template/Input/Select';
import MaskedInput from '../../Template/Input/MaskedInput';
import AddFilesCard from '../../../pages/Admin/AddFilesCard';
import { notifyError, notifySuccess } from '../../../utils/notify';
import oikosApi from '../../../services/oikos';
import moment from 'moment';
import { useSelector } from 'react-redux';
import { selectValues } from '../../../utils/fc';
import qs from 'qs';
import ModalFormularioSecundario from '../ModalFormularioSecundario/ModalFormularioSecundario';
import ModalFormAddPjOuPf from '../ModalFormAddPjOuPf/ModalFormAddPjOuPf';

// This component must recieve the openModal which is the variable that makes the modal render.
// This component must recieve the onClosed function which is the function that change the variable openModal.
// Both openModal variable and onClosed function should be defined in the parent component of this Modal.

const ModalFormulario = ( { openModal, title, size='sm', subtitle, tabela, onClosed, onConfirm, data, confirmButtonColor='primary', confirmButtonText = 'Confirmar', cancelButtonText = 'Cancelar', defaultInputs = {}, readOnly = false, ...props } ) => {

    const [inputs, setInputs] = useState(defaultInputs);
    const [addFormularioIsLoading, setAddFormularioIsLoading] = useState(false);
    const [isModalOpenningLoading, setIsModalOpenningLoading] = useState(false);
    const [isOpenModalFormularioSecundario, setIsOpenModalFormularioSecundario] = useState(false);
    const [perguntas, setPerguntas] = useState([]);
    const [formSecundario, setFormSecundario] = useState({});
    //
    const { user } = useSelector(state => state.auth);

    useEffect(() => {
      if (openModal) {
        setInputs(defaultInputs);
      }
    }, [openModal]);

    const checkCamposObrigatorios = () => {
      for (const campo of data) {
        if (campo.perguntaFormulario_obrigatoria === 1 && !inputs[campo.perguntaFormulario_label]) {
          notifyError(`O campo "${campo.perguntaFormulario_label}" é obrigatório.`)
          return false
        }
      }
      return true
    }

    const ordenarPorLabel = (lista) => {
      console.log('lista', lista)
      return lista.sort((a, b) => {
        if (!a.label || !b.label) return 0;
        const labelA = a.label.toLowerCase();
        const labelB = b.label.toLowerCase();

        if (labelA < labelB) return -1;
        if (labelA > labelB) return 1;
        return 0;
      });
    }

    const handleAddPesquisa = async () => {
      setAddFormularioIsLoading(true);

      if (!checkCamposObrigatorios()) {
        setAddFormularioIsLoading(false);
       return;
      }

      const formularioBody = {
          action: 'insert',
          table: 'formulario',
          data: {
            tpFormulario_id: 1 || undefined,
            formulario_dtCria: moment().format('YYYY-MM-DD hh:mm:ss'),
            formulario_dtMod: moment().format('YYYY-MM-DD hh:mm:ss'),
            formulario_usuarioCria: Number(user.pf_id),
            formulario_usuarioMod: Number(user.pf_id),
          },
      }

      const formularioCreated = await oikosApi.post('/', formularioBody);

      if (formularioCreated.data[0].formulario_id) {
        for (const campo of data) {
          let campoBody = {}
          if(campo.formatoCampo_id === 6) {
            campoBody = {
              action: 'insert',
              table: 'formularioDado',
              data: {
                perguntaFormulario_id: campo.perguntaFormulario_id,
                formularioDado_resposta: moment(inputs[campo.perguntaFormulario_label]).format('YYYY-MM-DD') || null,
                formularioDado_dtCria: moment().format('YYYY-MM-DD hh:mm:ss'),
                formularioDado_dtMod: moment().format('YYYY-MM-DD hh:mm:ss'),
                formularioDado_usuarioCria: Number(user.pf_id),
                formularioDado_usuarioMod: Number(user.pf_id),
                formulario_id: formularioCreated.data[0].formulario_id,
              },
            }
          } else {
            campoBody = {
              action: 'insert',
              table: 'formularioDado',
              data: {
                perguntaFormulario_id: campo.perguntaFormulario_id,
                formularioDado_resposta: inputs[campo.perguntaFormulario_label] || undefined,
                formularioDado_dtCria: moment().format('YYYY-MM-DD hh:mm:ss'),
                formularioDado_dtMod: moment().format('YYYY-MM-DD hh:mm:ss'),
                formularioDado_usuarioCria: Number(user.pf_id),
                formularioDado_usuarioMod: Number(user.pf_id),
                formulario_id: formularioCreated.data[0].formulario_id,
              },
            }
          }

          const res = await oikosApi.post('/', campoBody)
          console.log(res)
        }
      }

      setAddFormularioIsLoading(false);
      notifySuccess('Pesquisa adicionada com sucesso.');
    }

    const handleOpenModalFormularioSecundario = async (tpFormulario) => {
      setIsModalOpenningLoading(true);

      if (tpFormulario && tpFormulario.tpFormulario_id) {
        setFormSecundario(tpFormulario);
        const res = await oikosApi.get(`/?${qs.stringify({
          action: 'get',
          table: 'perguntaFormulario',
          data: {
            tpFormulario_id: tpFormulario.tpFormulario_id,
          },
        })}`);

        console.log(res.data);

        if (res.data.length > 0 && typeof(res.data) !== 'string') {
          for (const [index, pergunta] of res.data.entries()) {
            console.log(pergunta, index)
            if (pergunta.formatoCampo_id === 1 && pergunta.perguntaFormulario_tabRef) {
              const selOptions = await selectValues(pergunta.perguntaFormulario_tabRef, `${pergunta.perguntaFormulario_tabRef}_id`, pergunta.perguntaFormulario_selectLabel)
              const selOptionsSorted = ordenarPorLabel(selOptions);
              res.data[index].selOptions = selOptionsSorted;

            } else if (pergunta.formatoCampo_id === 1 && !pergunta.perguntaFormulario_tabRef && pergunta.perguntaFormulario_opcoes) {
              // Parse the string into an object
              const obj = JSON.parse(pergunta.perguntaFormulario_opcoes);
              // Convert the object into the desired array format
              const arr = Object.entries(obj).map(([label, value]) => ({
                label,
                value
              }));
              res.data[index].selOptions = arr;
            }
          }

          setPerguntas(res.data.sort((a, b) => a.perguntaFormulario_ord - b.perguntaFormulario_ord));
          setIsModalOpenningLoading(false);
          setIsOpenModalFormularioSecundario(true);
        } else {
          setIsModalOpenningLoading(false);
        }
      }

      setIsModalOpenningLoading(false);
    }

    return (
        <>
          <Modal size={size} isOpen={openModal} toggle={onClosed} centered zIndex={2000}>
              <div className='d-flex justify-content-between align-items-center pt-3 pr-4 pl-4'>
                <strong className='text-danger'>{title}</strong>
                <strong onClick={onClosed} style={{cursor: "pointer"}}>
                  <i className="ri-close-line" />
                </strong>
              </div>
              <ModalBody>
                  {subtitle &&
                    <h5>{subtitle}</h5>
                  }
                <Row>
                  {/*
                  <Col sm={3}>
                    <FormGroup>
                      <Label>
                        Descrição
                      </Label>
                      <Input
                        value={ inputs.documento_desc ? inputs['documento_desc'] : null }
                        onChange={e => setInputs({ ...inputs, documento_desc: e.target.value })}
                      />
                    </FormGroup>
                  </Col>
                  */}
                  {data.map((campo, index) => {
                      if (campo.formatoCampo_id === 6) {
                        return (
                          <Col sm={12} key={index}>
                            <FormGroup>
                              <Label>
                                {campo.perguntaFormulario_label}
                              </Label>
                              <DatePicker
                                placeholderText="__/__/_____"
                                locale="pt-BR"
                                className="form-control"
                                dateFormat="dd/MM/yyyy"
                                peekNextMonth
                                showMonthDropdown
                                showYearDropdown
                                dropdownMode="select"
                                disabled={readOnly}
                                selected={inputs[campo.perguntaFormulario_label] ? moment(inputs[campo.perguntaFormulario_label]).toDate() : null}
                                onChange={date => setInputs({...inputs, [campo.perguntaFormulario_label]: date } )}
                              />
                            </FormGroup>
                          </Col>
                        )
                      }

                      if (campo.formatoCampo_id === 3) {
                        return (
                          <Col sm={12} key={index}>
                            <FormGroup>
                              <Label>
                                {campo.perguntaFormulario_label}
                              </Label>
                              <Input
                                disabled={readOnly}
                                value={ inputs[campo.perguntaFormulario_label] ? inputs[campo.perguntaFormulario_label] : null }
                                onChange={e => setInputs({ ...inputs, [campo.perguntaFormulario_label]: e.target.value })}
                              />
                            </FormGroup>
                          </Col>
                        )
                      }

                      if (campo.formatoCampo_id === 1 && campo.perguntaFormulario_id !== 19) {
                        return (
                          <Col sm={12} key={index}>
                            <FormGroup>
                              <div className='d-flex justify-content-between align-items-center'>
                                <Label>
                                  {campo.perguntaFormulario_label}
                                </Label>

                                {campo.formSecundario &&
                                  campo.formSecundario.length > 0 &&
                                  !readOnly &&
                                  campo.formSecundario.map((formSec, idx) => (
                                    <>
                                      {console.log('formSec', formSec[idx])}
                                      {isModalOpenningLoading ?
                                        <Spinner size="sm" color="primary" />
                                        :
                                        <Button
                                          size="sm"
                                          color="link"
                                          className="ml-2 px-0"
                                          onClick={(e)=>{
                                            e.preventDefault();
                                            handleOpenModalFormularioSecundario(formSec[idx]);
                                          }}
                                        >
                                          Adicionar novo(a)
                                        </Button>
                                      }
                                    </>
                                  ))
                                }
                              </div>
                              <Select
                                isSearchable
                                isClearable={!defaultInputs[campo.perguntaFormulario_label]}
                                isDisabled={readOnly || !!defaultInputs[campo.perguntaFormulario_label]}
                                options={data ? data.find(c => c.perguntaFormulario_id === campo.perguntaFormulario_id).selOptions : []}
                                value={inputs[campo.perguntaFormulario_label] ? data.find(c => c.perguntaFormulario_id === campo.perguntaFormulario_id).selOptions.filter(op => op.value === inputs[campo.perguntaFormulario_label]) : null}
                                onChange={e => {
                                  e ? setInputs({ ...inputs, [campo.perguntaFormulario_label]: e.value }) : setInputs({ ...inputs, [campo.perguntaFormulario_label]: null })
                                }}
                              />
                            </FormGroup>
                          </Col>
                        )
                      }

                      if (campo.formatoCampo_id === 1 && campo.perguntaFormulario_id === 19) {
                        return (
                          <Col sm={12} key={index}>
                            <FormGroup>
                              <div className='d-flex justify-content-between align-items-center'>
                                <Label>
                                  {campo.perguntaFormulario_label}
                                </Label>
                                {!readOnly &&
                                  <ModalFormAddPjOuPf
                                    isPf={true}
                                    fetchSelPfs={props.fetchSelPfs}
                                  />
                                }
                              </div>
                              <Select
                                isSearchable
                                isClearable={!defaultInputs[campo.perguntaFormulario_label]}
                                isDisabled={readOnly || !!defaultInputs[campo.perguntaFormulario_label]}
                                options={props.selPfs.length > 0 ? props.selPfs : []}
                                value={inputs[campo.perguntaFormulario_label] ? props.selPfs.filter(p => p.value === inputs[campo.perguntaFormulario_label]) : null}
                                onChange={e => {
                                  e ? setInputs({ ...inputs, [campo.perguntaFormulario_label]: e.value }) : setInputs({ ...inputs, [campo.perguntaFormulario_label]: null })
                                }}
                              />
                            </FormGroup>
                          </Col>
                        )
                      }

                      if (campo.formatoCampo_id === 2) {
                        return (
                          <Col sm={12} key={index}>
                            <FormGroup>
                              <Label>
                                {campo.perguntaFormulario_label}
                              </Label>
                              <MaskedInput
                                unmask
                                mask="R$ num"
                                disabled={readOnly}
                                blocks={{
                                  num: {
                                    mask: Number,
                                    scale: 2, // digits after point 0 for integers
                                    signed: false, // disallow negative
                                    thousandsSeparator: '.', // any single char
                                    padFractionalZeros: false, // if true then pads zeros at end to the length of scale
                                    normalizeZeros: false, // appends or removes zeros at ends
                                    radix: ',', // fractional delimiter
                                    min: 0,
                                    max: 1000000000,
                                  },
                                }}
                                lazy={false}
                                value={inputs ? inputs[campo.perguntaFormulario_label] : ''}
                                onAccept={value => setInputs({ ...inputs, [campo.perguntaFormulario_label]: value })}
                              />
                            </FormGroup>
                          </Col>
                        )
                      }

                      if (campo.formatoCampo_id === 4) {
                        return (
                          <Col sm={12} key={index}>
                            <FormGroup>
                              <Label>
                                {campo.perguntaFormulario_label}
                              </Label>
                              <Input
                                type='number'
                                disabled={readOnly}
                                value={ inputs ? inputs[campo.perguntaFormulario_label] : null }
                                onChange={e => {
                                  console.log(campo.perguntaFormulario_label)
                                  setInputs({ ...inputs, [campo.perguntaFormulario_label]: Number(e.target.value) });
                                }}
                              />
                            </FormGroup>
                          </Col>
                        )
                      }
                  })}
                </Row>

                {/*
                <Row>
                  <Col>
                    <Card>
                      <CardHeader>
                        Anexos
                      </CardHeader>
                      <CardBody>
                        <AddFilesCard ref={newFilesRef} />
                      </CardBody>
                    </Card>
                  </Col>
                </Row>
                */}
              </ModalBody>
              <ModalFooter>
                {!readOnly && (!addFormularioIsLoading ? <Button color={confirmButtonColor} onClick={handleAddPesquisa}>{confirmButtonText}</Button> : <Spinner />)}
                <Button onClick={onClosed}>{readOnly ? 'Fechar' : cancelButtonText}</Button>
              </ModalFooter>
          </Modal>
          <ModalFormularioSecundario
            title="Formulário Secundario"
            openModal={isOpenModalFormularioSecundario}
            onClosed={() => setIsOpenModalFormularioSecundario(false)}
            data={perguntas}
            size='lg'
          />
        </>
    )
}

export default ModalFormulario;
